// extracted by mini-css-extract-plugin
module.exports = {"main":"footer-module--main--bj02a","grid":"footer-module--grid--1zm1W"};